
// @ts-nocheck


export const localeCodes =  [
  "fa",
  "en",
  "ar",
  "ru",
  "tr"
]

export const localeLoaders = {
  fa: [
    {
      key: "locale_fa_46json_3b5ed87c",
      load: () => import("#nuxt-i18n/3b5ed87c" /* webpackChunkName: "locale_fa_46json_3b5ed87c" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_483ecf8a",
      load: () => import("#nuxt-i18n/483ecf8a" /* webpackChunkName: "locale_en_46json_483ecf8a" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_6ed91b21",
      load: () => import("#nuxt-i18n/6ed91b21" /* webpackChunkName: "locale_ar_46json_6ed91b21" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_5399e38d",
      load: () => import("#nuxt-i18n/5399e38d" /* webpackChunkName: "locale_ru_46json_5399e38d" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_a30752a7",
      load: () => import("#nuxt-i18n/a30752a7" /* webpackChunkName: "locale_tr_46json_a30752a7" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fa",
      name: "فارسی",
      dir: "rtl",
      files: [
        {
          path: "/srv/sarvban_front/locales/fa.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      dir: "ltr",
      files: [
        {
          path: "/srv/sarvban_front/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      name: "العربية",
      dir: "rtl",
      files: [
        {
          path: "/srv/sarvban_front/locales/ar.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Русский",
      dir: "ltr",
      files: [
        {
          path: "/srv/sarvban_front/locales/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      name: "Türkçe",
      dir: "ltr",
      files: [
        {
          path: "/srv/sarvban_front/locales/tr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fa",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://sarvban.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fa",
    name: "فارسی",
    dir: "rtl",
    files: [
      {
        path: "/srv/sarvban_front/locales/fa.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    dir: "ltr",
    files: [
      {
        path: "/srv/sarvban_front/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    name: "العربية",
    dir: "rtl",
    files: [
      {
        path: "/srv/sarvban_front/locales/ar.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Русский",
    dir: "ltr",
    files: [
      {
        path: "/srv/sarvban_front/locales/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    name: "Türkçe",
    dir: "ltr",
    files: [
      {
        path: "/srv/sarvban_front/locales/tr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/